import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

const ConfigMenu = (props) => {
  const { selectedTab, setSelectedTab, configMenu } = props
  const theme = useTheme()

  const buttonStyle = {
    textTransform: 'capitalize',
    fontWeight: '500',
    color: theme.palette.grayX11,
    fontSize: '18px',

    '&:hover': {
      background: 'inherit',
      textDecoration: 'underline',
    },
  }

  const activeButtonStyle = {
    textTransform: 'capitalize',
    fontWeight: '500',
    color: theme.palette.violetsAreBlue,
    fontSize: '18px',
    textDecoration: 'underline',

    '&:hover': {
      background: 'inherit',      
    },
  }

  const handleClick = (value) => {
    setSelectedTab(value)
  }

  return (
    <Box sx={{ padding: '40px 0px 20px 0px' }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        justifyContent='flex-start'
        spacing={{ xs: 1, md: 4 }}
      >
        {
          configMenu.map((item, index) => (
            <Box key={index}>
              <Button
                variant='text'
                disableRipple
                disableElevation
                sx={item.value === selectedTab ? activeButtonStyle : buttonStyle}
                onClick={() => handleClick(item.value)}
              >
                {item.label}
              </Button>
            </Box>
          ))
        }
      </Stack>
    </Box>
  )
}

export default ConfigMenu